<template>
  <div class="box">
    <div v-for="(item, index) in data.itemList" :key="index">
      <div v-if="item.activityItemInfoDto && item.activityItemInfoDto.preSaleDto">
        <div class="header-nav">
          <div class="nav-left">{{ data.title || '订金升档' }}</div>
          <div class="nav-right">
            <countDown
              class="countdown"
              v-if="
                item.activityItemInfoDto &&
                  item.activityItemInfoDto.activityInfoDto &&
                  item.activityItemInfoDto.activityInfoDto.activityStatus !== 2
              "
              :endTime="
                item.activityItemInfoDto &&
                item.activityItemInfoDto.activityInfoDto &&
                item.activityItemInfoDto.activityInfoDto.activityStatus === 2
                  ? 0
                  : item.activityItemInfoDto &&
                    item.activityItemInfoDto.activityInfoDto &&
                    item.activityItemInfoDto.activityInfoDto.realStartTime > new Date().getTime()
                  ? item.activityItemInfoDto.activityInfoDto.realStartTime
                  : item.activityItemInfoDto &&
                    item.activityItemInfoDto.activityInfoDto &&
                    item.activityItemInfoDto.activityInfoDto.realEndTime > new Date().getTime()
                  ? item.activityItemInfoDto.activityInfoDto.realEndTime
                  : ''
              "
              :useNetTime="true"
              :text="text"
              @timeEnd="handleCountDown"
            />
            <div v-else class="text">活动已结束</div>
            <div class="text" v-if="item.activityItemInfoDto && item.activityItemInfoDto.activityInfoDto">
              {{
                item.activityItemInfoDto.activityInfoDto.activityStatus !== 2
                  ? item.activityItemInfoDto.activityInfoDto.realStartTime > new Date().getTime()
                    ? '后开始'
                    : '结束'
                  : ''
              }}
            </div>
          </div>
        </div>
        <div class="main">
          <div class="main-img">
            <img class="img" :src="item.mainImage" alt="" />
          </div>
          <div class="main-content" v-if="item.activityItemInfoDto && item.activityItemInfoDto.preSaleDto">
            <div
              class="cell"
              v-for="(e, i) in item.activityItemInfoDto.preSaleDto.ladders"
              :key="i"
              :style="{
                borderRight: i !== 2 ? '1px solid #D8D8D8' : ''
              }"
            >
              <div class="title">
                <p class="line"></p>
                <p class="text">{{ item.name }} {{ e.ladderName }}</p>
              </div>
              <div class="ad">{{ e.description }}</div>
              <div class="position-btn">
                <div class="content">
                  <div
                    class="activity-status"
                    v-if="
                      item.activityItemInfoDto &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.realStartTime >= new Date().getTime()
                    "
                  >
                    即将开始
                  </div>
                  <div class="activity-status" v-else>
                    <img class="tag" src="../../../assets/images/activity/fire.png" alt="" />
                    <p class="number">燃动值&nbsp;&nbsp;{{ e.popValue || 0 }}人</p>
                  </div>
                </div>
                <div class="footer">
                  <div
                    @click="reserve(item.id, item.type, e.ladderIndex, e.ifOrder)"
                    class="btn"
                    :style="{
                      background: e.ifOrder ? '#c6001f' : '#c6001f',
                      color: e.ifOrder ? '#fff' : '#fff'
                    }"
                  >
                    立即预定
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="upgrade">
          您可获得
          <p class="num">2</p>
          次权益升级资格，
          <p class="get" @click="toGet">去获取></p>
        </div> -->
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
      <span>此档位不可直接预定哦！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import countDown from '@/components/common/CountDown.vue'
export default {
  name: 'depositUp',
  components: { countDown },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      centerDialogVisible: false, // 对话框开启关闭
      flag: true, // 活动开始结束
      endTime: 0,
      text: '',
      endShow: true
    }
  },
  mounted() {},
  methods: {
    // 立即预定
    reserve(itemId, type, ladderIndex, ifOrder) {
      // if (!ifOrder) {
      //   this.centerDialogVisible = true
      // } else {
      let data
      if (ifOrder === false) {
        data = { id: itemId, ladderIndex: ladderIndex, ifOrder: ifOrder }
      } else {
        data = { id: itemId, ladderIndex: ladderIndex }
      }
      if (type === 0) {
        this.$router.push({ name: 'detailAllCars', query: data })
      } else {
        this.$router.push({ name: 'detailBoutiqueAccessories', query: data })
      }
      // }
    },
    confirm() {
      this.centerDialogVisible = false
      this.flag = false
    },
    cancel() {
      this.centerDialogVisible = false
      this.flag = true
    },
    // 倒计时结束
    handleCountDown() {
      // console.log('倒计时结束')
      this.endShow = false
      this.endTime = 0
    },
    toGet() {
      this.centerDialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 1360px;
  margin: 20px auto 0;
  .header-nav {
    height: 48px;
    line-height: 48px;
    background: linear-gradient(90deg, #c6001f 0%, #ffffff 100%);
    display: flex;
    justify-content: space-between;
    .nav-left {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 48px;
      padding-left: 24px;
    }
    .nav-right {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000;
      line-height: 22px;
      display: flex;
      height: 48px;
      line-height: 48px;
      padding-right: 17px;
      .countdown {
        color: #c60321;
      }
    }
  }
  .main {
    height: 260px;
    background-color: #ccc;
    // box-sizing: border-box;
    padding: 20px 0;
    background-color: #fff;
    display: flex;
    padding-left: 20px;
    .main-img {
      width: 390px;
      height: 230px;
      background: #ffffff;
      border: 1px solid #dedede;
      padding: 20px 0;
      text-align: center;
      .img {
        display: inline-block;
        width: 343px;
        height: 220px;
        object-fit: contain;
      }
    }
    .main-content {
      display: flex;
      flex-direction: row;
      background-color: #fff;
      .cell {
        width: 315px;
        text-align: center;
        position: relative;
        .title {
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #393c51;
          line-height: 40px;
          text-align: center;
          position: relative;
          .line {
            position: absolute;
            left: 65px;
            top: 32px;
            width: 3px;
            height: 17px;
            background: linear-gradient(180deg, #ffb983 0%, #ff834c 100%);
          }
          .text {
            // display: inline-block;
            font-size:20px;
            line-height:28px;
            font-weight:500;
            margin-top: 20px;
            max-width: 150px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-inline-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        .ad {
          display: inline-block;
          width: 130px;
          // height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #7a7a7a;
          line-height: 22px;
          height: 45px;
          // min-height: 45px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-inline-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .position-btn {
          position: absolute;
          left: 70px;
          bottom: 25px;
        }
        .content {
          width: 100%;
          text-align: center;
          .activity-status {
            // width: 62px;
            display:flex;
            height: 32px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #c6001f;
            line-height: 32px;
            margin-bottom: 10px;
            vertical-align: center;
            align-items: middle;
            .tag {
              display: inline-block;
              width: 24px;
              height: 24px;
              margin-right:3px;
              margin-top:-2px;
            }
            .number {
              display: inline-block;
              height: 22px;
              line-height: 22px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #c6001f;
            }
          }
        }
        .footer {
          width: 100%;
          text-align: center;
          .btn {
            display: inline-block;
            width: 167px;
            height: 33px;
            line-height: 33px;
            text-align: center;
            background: #ffffff;
            border: 1px solid #c6001f;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #c6001f;
            cursor: pointer;
          }
        }
      }
    }
  }
  .upgrade {
    height: 62px;
    line-height: 62px;
    text-align: center;
    background-color: #fff;
    margin-top: 10px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    .num {
      display: inline-block;
      color: #ff7b3a;
    }
    .get {
      display: inline-block;
      color: #ff7b3a;
      cursor: pointer;
    }
  }
}
</style>
